import * as React from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import * as _ from "lodash";

import style from "./Toggle.module.less";

export type ToggleProps = {
  /**
   * Handle click
   */
  onClick?: () => void;
  /**
   * toggle state
   */
  open: boolean;
};

/**
 * Game plan toggle component
 * @constructor
 */
const Toggle: React.FC<ToggleProps> = ({ onClick = _.noop, open }) => (
  <span data-testid="game-plan-toggle" className={style.Toggle} onClick={onClick}>
    {open ? <UpOutlined /> : <DownOutlined />}
  </span>
);

export default Toggle;
